import { useState, useEffect } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import find from "../../../assets/find.svg";
import "simplebar/dist/simplebar.min.css";
import { get, put, del } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import check from "../../../assets/images/check.svg";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import avatar from "../../../assets/images/personPlaceholder.png";
import moreIcon from "../../../assets/images/more.png";
import { toast, Bounce } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Placeholder from "../../../assets/images/Placeholder.gif";
const ListUser = () => {
  document.title = "Archive Users | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const itemsPerPage = 6;

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const toggleDropdown = (id) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const toggleModal = () => setModalOpen(!modalOpen);

  const fetchUsers = async (
    page,
    searchQuery = "",
    accStatus = "",
    startDate = "",
    endDate = ""
  ) => {
    setLoading(true);
    try {
      const response = await get(
        `${endpoints.user}?filter=archive&limit=${itemsPerPage}&page=${page}&accStatus=${accStatus}&search=${searchQuery}&startDate=${startDate}&endDate=${endDate}`
      );

      setUsersData(
        Array.isArray(response.data?.data) ? response.data.data : []
      );
      setTotalPages(response.data?.totalPages || 1);

      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      setUsersData([]);
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async (id) => {
    setLoading(true);
    try {
      const response = await del(`${endpoints.user}/${id}`);

      fetchUsers(currentPage, searchTerm);

      toast.success("User Deleted successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchUsers(currentPage);
      setModalOpen(false);
    } catch (error) {
      toast.error("Failed to delete user.");
    } finally {
      setLoading(false);
    }
  };

  const updateUserStatus = async (id, status) => {
    setLoading(true);
    try {
      const response = await put(`${endpoints.user}/status/${id}`, { status });

      fetchUsers(currentPage, searchTerm);

      switch (status) {
        case "active":
          toast.success(`User Active Successfully`, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          break;
        case "delete":
          toast.success(`User Deleted successfully`, {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
          break;
        default:
          break;
      }
    } catch (error) {
      toast.error("Failed to update user status.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div>
      <Container fluid>
        <Row className="g-0">
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                  {/* Title and Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    {/* Title */}
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Archived Users
                    </span>

                    {/* Search Bar */}
                    <div
                      className="w-100 w-sm-auto bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{
                        borderRadius: "12px",
                        height: "48px",
                        maxWidth: "400px",
                      }} // Added maxWidth
                    >
                      {/* Search Icon */}
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />

                      {/* Search Input */}
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>
                </div>
                <>
                  {" "}
                  <div
                    className="table-responsive hide-scrollbar"
                    style={{
                      height: usersData?.length > 0 ? "500px" : "auto",
                    }}
                  >
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap"
                    >
                      <thead>
                        <tr>
                          <th className="ff-sora">ID</th>
                          <th className="ff-sora">User</th>
                          <th className="ff-sora">Passes Purchased</th>
                          <th className="ff-sora">Social Link</th>
                          <th className="ff-sora">Account Status</th>
                          <th className="ff-sora">Registered On</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : usersData.length === 0 ? (
                          <></>
                        ) : (
                          usersData.map((user, index) => (
                            <tr key={user.id + index}>
                              <td className="ff-sora">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>
                                <div className="d-flex align-items-center ff-sora">
                                  <img
                                    src={
                                      user.additionalInfo?.profileImage
                                        ? `${process.env.REACT_APP_IMG_URL}${user.additionalInfo.profileImage}`
                                        : avatar
                                    }
                                    alt={`${user.firstName} ${user.lastName} avatar`}
                                    className="avatar-xs rounded-circle object-fit-cover me-2"
                                    width="48"
                                    height="48"
                                    onError={(e) => {
                                      e.target.src = avatar;
                                    }}
                                  />
                                  <div>
                                    <h6 className="font-size-14 mb-1 ff-sora fw-normal secondary-black">
                                      {user.firstName && user.lastName
                                        ? `${user.firstName
                                            .charAt(0)
                                            .toUpperCase()}${user.firstName
                                            .slice(1)
                                            .toLowerCase()} ${user.lastName
                                            .charAt(0)
                                            .toUpperCase()}${user.lastName
                                            .slice(1)
                                            .toLowerCase()}`
                                        : "N/A"}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td className="ff-sora">
                                {user.passes || "N/A"}
                              </td>
                              <td className="ff-sora">
                                {user.additionalInfo?.sociallink || "N/A"}
                              </td>
                              <td>
                                <span
                                  className={`badge font-size-14 fw-normal py-2 px-2 ff-sora ${
                                    user.emailVerified
                                      ? "bg-soft-success"
                                      : "bg-warning-subtle text-warning"
                                  }`}
                                >
                                  {user.emailVerified
                                    ? "Verified"
                                    : "Un-Verified"}
                                </span>
                              </td>
                              <td className="ff-sora">
                                {user.createdAt
                                  ? new Date(
                                      user.createdAt
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td>
                                <Dropdown
                                  isOpen={dropdownOpen[user.id] || false}
                                  toggle={() => toggleDropdown(user.id)}
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <DropdownItem
                                      className="font-size-14 fw-normal ff-sora"
                                      onClick={() =>
                                        updateUserStatus(user.id, "active")
                                      }
                                    >
                                      Active
                                    </DropdownItem>
                                    {/* <DropdownItem
                                        className="font-size-14 fw-normal ff-sora"
                                        onClick={() =>
                                          updateUserStatus(user.id, "delete")
                                        }
                                      >
                                        Archive
                                      </DropdownItem> */}
                                    <DropdownItem
                                      className="font-size-14 fw-normal ff-sora"
                                      onClick={() => {
                                        setSelectedUserId(user.id);
                                        toggleModal();
                                      }}
                                    >
                                      Permanent Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {!loading && usersData?.length === 0 && (
                      <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                        <img
                          src={Placeholder}
                          alt="No record placeholder"
                          className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                        />
                        <p className="text-center ff-sora font-size-16 fw-normal">
                          No User Found!
                        </p>
                      </div>
                    )}
                  </div>
                </>
              </CardBody>
            </Card>{" "}
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page) => (
                    <Button
                      key={page + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>{" "}
          </Col>
        </Row>
      </Container>

      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        className="modal-dialog-centered rounded-4"
      >
        <ModalHeader
          toggle={toggleModal}
          className="font-size-16 fw-medium ff-sora"
        >
          Confirm Deletion
        </ModalHeader>
        <ModalBody className="font-size-14 fw-normal ff-sora">
          Are you sure you want to delete this user?
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            className=" rounded-pill"
            onClick={() => {
              if (selectedUserId) {
                deleteUser(selectedUserId);
              }
            }}
          >
            Confirm
          </Button>
          <Button color="white" className="rounded-pill1" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ListUser;
